import { LegalObjectType, PhysicalObjectType } from '../../../providers/ActivationObjectProvider/types'
import { GenericDropdownItem } from '../../../../types'
import { WizzardStep2Form } from '../types'

export const DefaultValue: WizzardStep2Form = {
    objectAddressID: '',
    objectZIP: '',
    objectCity: '',
    objectStreet: '',
    objectCodeNumber: '',
    objectGuidanceNumber: '',
    objectParcelNumber: '',
    objectRegistrationNumber: '',
    objectGPS: undefined,
    guaranteedArrivalTime: 0,
    objectType: '',
    objectTypeAnother: '',
    objectDesription: '',
    objectSize: null,
    confirmObjectGPS: false,
}

export const PhysicalObjectTypeDesc: Record<PhysicalObjectType, string> = {
    FamilyHouse: 'Rodinný dům',
    Flat: 'Byt',
    Deposit: 'Sklad',
    RecreationalObject: 'Rekreační objekt',
    GarageOrWorkshop: 'Garáž nebo dílna',
    Another: 'Jiný',
}

export const PhysicalObjectTypeList: GenericDropdownItem<PhysicalObjectType>[] = Object.keys(PhysicalObjectTypeDesc).map(
    (key) => {
        return {
            value: key as PhysicalObjectType,
            label: (PhysicalObjectTypeDesc as any)[key],
        }
    }
)

export const LegalObjectTypeDesc: Record<LegalObjectType, string> = {
    Flat: 'Byt',
    Shop: 'Prodejna',
    Office: 'Kancelář',
    Bank: 'Banka',
    Restaurant: 'Restaurace',
    Deposit: 'Sklad',
    RecreationalObject: 'Rekreační objekt',
    CarServices: 'Autoservis',
    PetrolStation: 'Benzinová stanice',
    Playroom: 'Hračkářství',
    Hotel: 'Hotel',
    Pharmacy: 'Lékárna',
    SolarPowerStation: 'Solární elektrárna',
    SportsObject: 'Sportovní objekt',
    BuildingMaterials: 'Stavebniny',
    School: 'Škola',
    StateOffice: 'Státní kancelář',
    ProductionFacility: 'Výrobní zařízení',
    HealthCareFacility: 'Zdravotnické zařízení',
    GoldsmithingOrAntiques: 'Zlatnictví nebo starožitnictví',
    Another: 'Jiný',
}

export const LegalObjectTypeList: GenericDropdownItem<LegalObjectType>[] = Object.keys(LegalObjectTypeDesc).map((key) => {
    return {
        value: key as LegalObjectType,
        label: (LegalObjectTypeDesc as any)[key],
    }
})

export const ObjectDescriptionHelper: Record<PhysicalObjectType | LegalObjectType, string> = {
    FamilyHouse: 'počet podlaží, barva fasády, typ a barva střechy, typ a barva oplocení',
    Flat: 'číslo bytu, patro, umístění na patře, popis vstupních dveří ',
    Another: 'účel objektu, barva fasády, počet podlaží, typ a barva střechy, typ a barva oplocení',
    Shop: 'název prodejny, barva fasády, počet a barva přístupových dveří',
    Office: 'barva fasády, počet a barva přístupových dveří, číslo/označení dveří',
    Bank: '',
    Restaurant: '',
    Deposit: '',
    RecreationalObject: '',
    CarServices: '',
    PetrolStation: '',
    Playroom: '',
    Hotel: '',
    Pharmacy: '',
    SolarPowerStation: '',
    SportsObject: '',
    BuildingMaterials: '',
    School: '',
    StateOffice: '',
    ProductionFacility: '',
    HealthCareFacility: '',
    GoldsmithingOrAntiques: '',
    GarageOrWorkshop: '',
}
